import { c as _c } from "react/compiler-runtime";
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import BaseConfiguration from 'modules/funnels/funnel/components/step-configuration-tab/base-configuration-tab/components/base-configuration';
import SplitTestPreviewStepModal from 'modules/funnels/funnel/components/step-configuration-tab/split-test-preview-step-modal';
import StepConfigurationTabLayout from 'modules/funnels/funnel/components/step-configuration-tab/step-configuration-tab-layout';
import { useBaseFunnelStepConfigurationSettings } from 'modules/funnels/funnel/hooks/use-base-funnel-step-configuration-settings';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import { useFunnelStepsList } from 'modules/funnels/funnel/hooks/use-funnel-steps-list';
import { useResetFunnelStepPageTemplate } from 'modules/funnels/funnel/hooks/use-reset-funnel-step-page-template';
import { useUpdateBaseConfigurationTab } from 'modules/funnels/funnel/hooks/use-update-base-configuration-tab';
import { BaseFunnelStepConfigurationEditInterface, BaseFunnelStepConfigurationInterface } from 'modules/funnels/funnel/types/base-funnel-step-configuration-settings-interface';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { getFunnelStepPreviewData } from 'modules/funnels/funnel/utils/get-funnel-step-split-test-preview-data';
import { getFunnelStepPageUrl, getFunnelStepPreviewUrl } from 'modules/funnels/funnel/utils/page-utils';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React, { useState } from 'react';
import { Loader } from 'shared/components/loader';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getPageEditorUrl } from 'shared/utils/get-page-editor-url';
interface BaseConfigurationTabProps {
  funnelStep: FunnelStepInterface;
  funnelId: FunnelId;
  showPreview?: boolean;
}
function BaseConfigurationTab(t0) {
  const $ = _c(45);
  const {
    funnelStep,
    funnelId,
    showPreview
  } = t0;
  const {
    funnelStepConfigurationSettings,
    mutateFunnelStepConfigurationSettings
  } = useBaseFunnelStepConfigurationSettings(funnelStep.id);
  const {
    t
  } = useLocoTranslation();
  const {
    funnel
  } = useFunnel(funnelId);
  const {
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  let t1;
  if ($[0] !== funnelId || $[1] !== funnelStep.id) {
    t1 = {
      funnelId,
      funnelStepId: funnelStep.id
    };
    $[0] = funnelId;
    $[1] = funnelStep.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    resetFunction
  } = useResetFunnelStepPageTemplate(t1);
  const [splitTestPreviewOpen, setSplitTestPreviewOpen] = useState(false);
  const t2 = `${FUNNELS_API}/steps/${funnelStep.id}`;
  let t3;
  if ($[3] !== funnelId || $[4] !== funnelStep.id || $[5] !== t2) {
    t3 = {
      funnelStepId: funnelStep.id,
      funnelId,
      updateUrl: t2
    };
    $[3] = funnelId;
    $[4] = funnelStep.id;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    updateFetcher
  } = useUpdateBaseConfigurationTab(t3);
  let t4;
  if ($[7] !== funnelStep.id || $[8] !== mutateFunnelStepConfigurationSettings || $[9] !== mutateFunnelStepsList || $[10] !== updateFetcher) {
    t4 = async baseData => {
      ;
      try {
        await updateFetcher(baseData, async () => {
          await mutateFunnelStepConfigurationSettings(data => {
            if (data) {
              return {
                ...data,
                name: baseData.name,
                page: {
                  ...data.page,
                  path: baseData.page.path
                }
              };
            }
          }, false);
          await mutateFunnelStepsList(data_0 => {
            if (data_0) {
              return data_0.map(dataFunnelStep => {
                if (dataFunnelStep.id === funnelStep.id) {
                  return {
                    ...dataFunnelStep,
                    name: baseData.name
                  };
                }
                return dataFunnelStep;
              });
            }
          }, false);
        });
      } catch (t5) {
        const e = t5;
        throw e;
      }
    };
    $[7] = funnelStep.id;
    $[8] = mutateFunnelStepConfigurationSettings;
    $[9] = mutateFunnelStepsList;
    $[10] = updateFetcher;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleSave = t4;
  if (!funnelStepConfigurationSettings || !funnel || !funnelStep.page) {
    let t5;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="flex h-full items-center justify-center py-12"><Loader className="scale-150" /></div>;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    return t5;
  }
  let t5;
  if ($[13] !== funnel.domain.domainName || $[14] !== funnelStepConfigurationSettings.page.path || $[15] !== showPreview) {
    t5 = showPreview ? getFunnelStepPreviewUrl(funnel.domain.domainName, funnelStepConfigurationSettings.page.path) : getFunnelStepPageUrl(funnel.domain.domainName, funnelStepConfigurationSettings.page.path);
    $[13] = funnel.domain.domainName;
    $[14] = funnelStepConfigurationSettings.page.path;
    $[15] = showPreview;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const viewLinkUrl = t5;
  const t6 = !showPreview;
  let t7;
  if ($[17] !== funnel || $[18] !== funnelStep || $[19] !== showPreview || $[20] !== t || $[21] !== t6) {
    t7 = getFunnelStepPreviewData({
      funnelStep,
      setOpen: setSplitTestPreviewOpen,
      funnel,
      t,
      showPreview,
      previewLinkWithQuery: t6
    });
    $[17] = funnel;
    $[18] = funnelStep;
    $[19] = showPreview;
    $[20] = t;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const {
    customViewButton,
    funnelStepAPreviewLink,
    funnelStepBPreviewLink,
    isSplitTestPreview
  } = t7;
  let t8;
  if ($[23] !== funnelStep.page.id) {
    t8 = getPageEditorUrl(funnelStep.page.id);
    $[23] = funnelStep.page.id;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  const t9 = funnel?.domain.domainName;
  let t10;
  if ($[25] !== funnelStep.inRunningSplitTest || $[26] !== funnelStepConfigurationSettings.name || $[27] !== funnelStepConfigurationSettings.page.path || $[28] !== handleSave || $[29] !== t9) {
    t10 = <BaseConfiguration onSave={handleSave} domainName={t9} name={funnelStepConfigurationSettings.name} path={funnelStepConfigurationSettings.page.path} pathDisabled={funnelStep.inRunningSplitTest} />;
    $[25] = funnelStep.inRunningSplitTest;
    $[26] = funnelStepConfigurationSettings.name;
    $[27] = funnelStepConfigurationSettings.page.path;
    $[28] = handleSave;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== customViewButton || $[32] !== resetFunction || $[33] !== t10 || $[34] !== t8 || $[35] !== viewLinkUrl) {
    t11 = <StepConfigurationTabLayout viewLinkUrl={viewLinkUrl} editLinkUrl={t8} customViewButton={customViewButton} onChangeTemplate={resetFunction}>{t10}</StepConfigurationTabLayout>;
    $[31] = customViewButton;
    $[32] = resetFunction;
    $[33] = t10;
    $[34] = t8;
    $[35] = viewLinkUrl;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== funnelStepAPreviewLink || $[38] !== funnelStepBPreviewLink || $[39] !== isSplitTestPreview || $[40] !== splitTestPreviewOpen) {
    t12 = isSplitTestPreview && <SplitTestPreviewStepModal open={splitTestPreviewOpen} setOpen={setSplitTestPreviewOpen} stepAPreviewLink={funnelStepAPreviewLink} stepBPreviewLink={funnelStepBPreviewLink} />;
    $[37] = funnelStepAPreviewLink;
    $[38] = funnelStepBPreviewLink;
    $[39] = isSplitTestPreview;
    $[40] = splitTestPreviewOpen;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  let t13;
  if ($[42] !== t11 || $[43] !== t12) {
    t13 = <>{t11}{t12}</>;
    $[42] = t11;
    $[43] = t12;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  return t13;
}
export default BaseConfigurationTab;